// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2LHGC","col":"Table_col__3VOTC","fulfillmentStatus":"Table_fulfillmentStatus__Z7QrI","emailCol":"Table_emailCol__bP9Lp"};